module.exports = __webpack_public_path__ + "static/media/label-5-over.312a8f30.svg";